import { loadLoyaltyIsBenefitAvailable } from ".";
import { MEMBERS_ONLY_SALE } from "../constants";

const loadLoyaltyIsMembersOnlySaleAvailableForTier = () => async dispatch => {
  dispatch(loadLoyaltyIsBenefitAvailable(MEMBERS_ONLY_SALE));
};

export default loadLoyaltyIsMembersOnlySaleAvailableForTier;
